import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, convertToNumber, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBox, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const CompanyMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const Hide = false;
    const [formData, setFormData] = useState({
        "companyID": '',
        "companyCode": '',
        "companyName": '',
        "contactPerson": '',
        "address1": '',
        "address2": '',
        "address3": '',
        "cityCode": '',
        "stateCode": '',
        "countryCode": '',
        "pinCode": '',
        "phoneNo": '',
        "faxNo": '',
        "emailID": '',
        "serviceTaxNo": '',
        "panNo": '',
        "website": '',
        "billingCurrencyCode": '',
        "active": true
    })

    const handleClear = () => {
        setFormData({
            "companyID": '',
            "companyCode": '',
            "companyName": '',
            "contactPerson": '',
            "address1": '',
            "address2": '',
            "address3": '',
            "cityCode": '',
            "stateCode": '',
            "countryCode": '',
            "pinCode": '',
            "phoneNo": '',
            "faxNo": '',
            "emailID": '',
            "serviceTaxNo": '',
            "panNo": '',
            "website": '',
            "billingCurrencyCode": '',
            "active": true
        });
        filterData.SearchText = ''
        getCompanyMasterData()
       // inputrefs.current['txtCompanyCode'].focus();
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateCompanyMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteCompanyMaster', { companyID: ID }, getCompanyMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditCompanyMaster', { companyID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    const getCompanyMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowCompanyMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getCompanyMasterData(value);
    };

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    useEffect(() => {
        getCompanyMasterData();
    }, [sortConfig])

    useEffect(() => {
        //inputrefs.current['txtCompanyCode'].focus();
        document.title = 'Company Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText :FindTranslatedKey('Company Master')}</h6>
                </div>
                <div className='card-body row'>
                   {/* {Hide ? <>*/}
                        <div className='row'>
                            <InputBox
                                label='Company Code'
                                PlaceHolderText='Company Code'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCompanyCode'
                                disabled={disableEdit}
                                value={formData.companyCode}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, companyCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCompanyName'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Company Name'
                                PlaceHolderText='Company Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCompanyName'
                                value={formData.companyName}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, companyName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtContactPerson'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Contact Person'
                                PlaceHolderText='Contact Person'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtContactPerson'
                                value={formData.contactPerson}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, contactPerson: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress1'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Address 1'
                                PlaceHolderText='Address 1'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtAddress1'
                                value={formData.address1}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address1: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress2'].focus();
                                    }
                                }}
                            /><InputBox
                                label='Address 2'
                                PlaceHolderText='Address 2'
                                inputrefs={inputrefs}
                                id='txtAddress2'
                                value={formData.address2}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address2: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress3'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Address 3'
                                PlaceHolderText='Address 3'
                                inputrefs={inputrefs}
                                id='txtAddress3'
                                value={formData.address3}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address3: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCountryCode'].focus();
                                    }
                                }}
                            />
                            <AutoCompleteBox
                                label='Country'
                                placeholder='Country'
                                inputValue={formData.countryCode ? formData.countryCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                        setFormData({ ...formData, countryCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCountryCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtStateCode'].focus() };
                                }}
                            />

                            <AutoCompleteBox

                                label='State'
                                placeholder='State'
                                inputValue={formData.stateCode ? formData.stateCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.countryCode, 'GetState_CountryWise');
                                        setFormData({ ...formData, stateCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtStateCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtCityCode'].focus() };
                                }}
                            />

                            <AutoCompleteBox
                                label='City'
                                placeholder='City'
                                inputValue={formData.cityCode ? formData.cityCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.stateCode, 'GetCity_StateWise');
                                        setFormData({ ...formData, cityCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCityCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPinCode'].focus() };
                                }}
                            />
                            <AutoCompleteBox
                                label='Pin Code'
                                placeholder='Pin Code'
                                inputValue={formData.pinCode ? formData.pinCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.cityCode, 'GetPinCode_CityWise');
                                        setFormData({ ...formData, pinCode: newInputValue })
                                    }}
                                maxLength='6'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPinCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPhoneNo'].focus() };
                                }}
                            />

                            <InputBox
                                label='Phone Number'
                                PlaceHolderText='Phone Number'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPhoneNo'
                                value={formData.phoneNo}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, phoneNo: convertToNumber(e.target.value) })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtFaxNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Fax No'
                                PlaceHolderText='Fax No'
                                required={false}
                                inputrefs={inputrefs}
                                id='txtFaxNo'
                                value={formData.faxNo}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, faxNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailID'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Email ID'
                                PlaceHolderText='Email ID'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtEmailID'
                                value={formData.emailID}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, emailID: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtServiceTaxNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Service Tax No'
                                PlaceHolderText='Service Tax No'
                                inputrefs={inputrefs}
                                id='txtServiceTaxNo'
                                value={formData.serviceTaxNo}
                                maxLength='30'
                                onChange={(e) => {
                                    setFormData({ ...formData, serviceTaxNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtPanNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Pan No'
                                PlaceHolderText='Pan No'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPanNo'
                                value={formData.panNo}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, panNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtWebsite'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Website'
                                PlaceHolderText='Website'
                                inputrefs={inputrefs}
                                id='txtWebsite'
                                value={formData.website}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, website: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBillingCurrencyCode'].focus();
                                    }
                                }}
                            /><InputBox
                                label='Billing Currency Code'
                                PlaceHolderText='Billing Currency Code'
                                inputrefs={inputrefs}
                                id='txtBillingCurrencyCode'
                                value={formData.billingCurrencyCode}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, billingCurrencyCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus();
                                    }
                                }}
                            />

                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='txtActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />

                        </div>
                   {/* </> : <></>}*/}
                   
                    <div className='row pb-1'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            //save={false}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/Master/ShowCompanyMaster', filterData, 'Company Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={'CompanyMaster'}
                        loading={loading}
                        handleFilter={() => {
                            getCompanyMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
            </div>

           
        </>
    )
}

export default CompanyMaster;